// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — video-cap.classic.js, новая — video-cap.cp.js
import { isCp } from 'libs/design';
import * as classic from './video-cap.classic';
import * as cp from './video-cap.cp';

export const TwoVideosPlace = isCp ? cp.TwoVideosPlace : classic.TwoVideosPlace;
export const VideoCap = isCp ? cp.VideoCap : classic.VideoCap;
